module.exports = __webpack_public_path__ + "img/wiggle02.f304d68c.jpg";